export const logoUrl =
  'https://college-official.oss-cn-hangzhou.aliyuncs.com/materials/home/logo-1.png';
